import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Calendar, User } from "lucide-react";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    api.get(`/blogs/${slug}`).then((r) => setBlog(r.data)).catch(() => setBlog(false));
  }, [slug]);

  if (blog === false) return <div className="section-padding container-fr">This article is not available in the current website archive. <Link to="/blog" className="text-[#2A9D8F] underline">Back to articles</Link>.</div>;
  if (!blog) return <div className="section-padding container-fr">Loading...</div>;

  return (
    <>
      <SEO title={blog.title} description={blog.excerpt} path={`/blog/${slug}`} />

      <article className="bg-white">
        <div className="bg-[#0B2545] text-white py-20 px-6 md:px-12 lg:px-24">
          <div className="container-fr max-w-3xl">
            <Link to="/blog" className="inline-flex items-center gap-2 text-[#2A9D8F] text-sm font-medium mb-6 hover:underline">
              <ArrowLeft size={14} /> Back to all articles
            </Link>
            <h1 className="font-display text-3xl md:text-5xl font-black leading-tight">{blog.title}</h1>
            <div className="flex items-center gap-4 mt-6 text-sm text-slate-300">
              <span className="inline-flex items-center gap-2"><User size={14} />{blog.author}</span>
              <span className="inline-flex items-center gap-2"><Calendar size={14} />{new Date(blog.created_at).toLocaleDateString()}</span>
            </div>
          </div>
        </div>

        {blog.image_url && (
          <div className="container-fr px-6 md:px-12 lg:px-24 -mt-10 max-w-4xl">
            <img src={blog.image_url} alt={blog.title} className="rounded-xl w-full h-[420px] object-cover shadow-xl" />
          </div>
        )}

        <div className="section-padding container-fr max-w-3xl prose prose-slate">
          <p className="text-xl text-slate-700 leading-relaxed font-medium">{blog.excerpt}</p>
          <div className="mt-8 text-slate-700 leading-relaxed whitespace-pre-wrap">
            {blog.content}
          </div>
          {blog.tags?.length > 0 && (
            <div className="mt-10 flex flex-wrap gap-2">
              {blog.tags.map((t) => (
                <span key={t} className="text-xs uppercase tracking-wider font-semibold text-[#2A9D8F] bg-[#2A9D8F]/10 px-3 py-1.5 rounded-full">{t}</span>
              ))}
            </div>
          )}
        </div>
      </article>
    </>
  );
}
